// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './components/Home';
import Configurator from './components/Configurator';
import './App.css';

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="app">
        <Routes>
          {/* <Route path="/" element={<Home />} /> */}
          {/* <Route path="/configurator" element={<Configurator />} /> */}
          <Route path="/" element={<Configurator />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;